import { render } from "./ActiveStoresRateCard.vue?vue&type=template&id=5da7f9d8"
import script from "./ActiveStoresRateCard.vue?vue&type=script&lang=js"
export * from "./ActiveStoresRateCard.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./ActiveStoresRateCard.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_36689b7c%2Fpackages%2Fstore%2Fsrc%2Fcomponents%2Fanalytics%2FActiveStoresRateCard.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__